import { gql } from "apollo-boost"

export default gql`
  query LoadAboutPage {
    aboutPage {
      body
    }
  }
`
